<script setup lang="ts">
import Button from './Button.vue'

defineProps<{ to?: string; size?: 'sm' | 'xs' }>()
</script>

<template>
  <NuxtLink
    v-if="to"
    :to="to"
    class="cursor-pointer rounded-md px-2 py-1 text-neutral-700 hover:bg-neutral-100 hover:text-neutral-900 focus:bg-neutral-100"
  >
    <span class="body-2 flex items-center">
      Close
      <i
        class="i-ph-x-bold block"
        :class="{
          'h-5 w-5': !size || size === 'sm',
          'h-4 w-4': size === 'xs',
        }"
      />
    </span>
  </NuxtLink>
  <Button
    v-else
    class="px-2 py-1 text-neutral-700 hover:bg-neutral-100 hover:text-neutral-900 focus:bg-neutral-100"
    :size="size ?? 'sm'"
    variant="text"
  >
    <span class="body-2 flex items-center">
      Close
      <i
        class="i-ph-x-bold block"
        :class="{
          'h-5 w-5': !size || size === 'sm',
          'h-4 w-4': size === 'xs',
        }"
      />
    </span>
  </Button>
</template>
